var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-trumbowyg',{attrs:{"config":_vm.config},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }